module.exports = __webpack_public_path__ + "static/media/empty_foto.24377e75.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/web/pages/lojas/empty_foto.jpg
// module id = 1504
// module chunks = 0